import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import HeadSub from '../../../components/comm/HeadSub';
import CustomSelectBox from '../../../components/box/CustomSelectBox';
import style from './ServicePolicyDetail.module.css';
import axiosApi from '../../../api/daonAxios';
import CODE from '../../../constants/code';
import MSG from '../../../constants/message';


const ServicePolicyDetail = () => {
    const location = useLocation();

    const isFirstRender = useRef(true);

    const { id = null, stplatPolicySeCd = null } = location.state || {};

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [policyDetail, setPolicyDetail] = useState({}); 
    const [enfcYmdList, setEnfcYmdList] = useState([]); 

    const retrieveAppPolicy = useCallback(async (id, stplatPolicySeCd) => {
        const url = "/setting/retrieveAppPolicy";
        const jToken = localStorage.getItem('jToken');
        const reqOptions = { 
            headers: { "Authorization": `Bearer ${jToken}`, } ,
        };
        await axiosApi.post(url, {id : id, stplatPolicySeCd : stplatPolicySeCd }, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) { 
                setPolicyDetail(prev => ({...prev, ...res.data.result}));
                console.log(res.data.result)
            } else {
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
        })
        .catch(err => {
            setToastMessage('약관 호출 중 오류');
            setToast(true);
        })
    }, []);
    
    const retrieveAppPolicyEnfcYmdList = useCallback(async () => {
        const url = "/setting/retrieveAppPolicyEnfcYmdList";
        const jToken = localStorage.getItem('jToken');
        const reqOptions = { 
            headers: { "Authorization": `Bearer ${jToken}`, } ,
        };
        await axiosApi.post(url, {stplatPolicySeCd : stplatPolicySeCd }, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) { 

                const enfcList = res.data.result.map(item => ({
                                        value: item.id,
                                        label: item.enfcYmd
                                    }))

                setEnfcYmdList([...enfcList]);
                console.log(res.data.result)
            } else {
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
        })
        .catch(err => {
            setToastMessage('약관 시행일 호출 중 오류');
            setToast(true);
        })
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            await retrieveAppPolicyEnfcYmdList();
            await retrieveAppPolicy(id, stplatPolicySeCd); // 먼저 실행되고 완료될 때까지 기다림
        };

        if (isFirstRender.current) {
            isFirstRender.current = false;
            fetchData();
            return;
        }
    },[])

    const handleChangeDate = (id) => {
        retrieveAppPolicy(id, stplatPolicySeCd)
    }

    if(!id || !stplatPolicySeCd) {
        setToastMessage('잘못된 접근 입니다.');
        setToast(true);
        return;
    }

    const wrapTables = (html) => {
        if (!html) return '';
        return html.replace(/<table([\s\S]*?)<\/table>/gi, `<div class="${style['table-wrapper']}"><table$1</table></div>`);
    };

    return (
        <>
            <HeadSub title="상세보기" />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" data-pad="normal">
                    <div className={style['notice-detail-box']}>
                        <div className={style['head']}>
                            <p className={style['title']}>{policyDetail.stplatPolicySj}</p>
                        </div>

                        <div className={style['select-box']}>
                            <span>개정 내역</span>
                            <CustomSelectBox optionData={enfcYmdList} onChage={(id) => handleChangeDate} />
                        </div>

                        <div className={style['mid']}>
                            <div className={style['content']}>
                                <div className={style['txt-box']}
                                    dangerouslySetInnerHTML={{ __html: wrapTables(policyDetail.stplatPolicyCn || '') }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ServicePolicyDetail;